import { useState } from 'react';

import { OutOfOfficeWidget, type THoliday } from '@crehana/compass.dashlets';
import { useFeatureFlag } from '@crehana/feature-flags/react';

import { useOutOfOfficeData } from '../../hooks/use-out-of-office-data';
import { ModalHolidayDetails } from './components/modal-holiday-details';

export const OutOfOfficeWidgetContainer: React.FC = () => {
  const [selectedHoliday, setSelectedHoliday] = useState<THoliday | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { flagValue: isOutOfOfficeWidgetEnabled, loading: loadingFeatureFlag } =
    useFeatureFlag('WIDGET_OUT_OF_OFFICE');

  const {
    loading,
    error,
    refetch,
    outOfOfficeUsers,
    holidays,
    upcomingOutOfOfficeUsers,
    upcomingHolidays,
  } = useOutOfOfficeData();

  const handleShowUsers = (holiday: THoliday) => {
    console.log('holiday', holiday);
    setSelectedHoliday(holiday);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedHoliday(null);
  };

  if (loadingFeatureFlag || !isOutOfOfficeWidgetEnabled) {
    return null;
  }

  return (
    <>
      <OutOfOfficeWidget
        outOfOfficeUsers={outOfOfficeUsers}
        holidays={holidays}
        upcomingOutOfOfficeUsers={upcomingOutOfOfficeUsers}
        upcomingHolidays={upcomingHolidays}
        loading={loading}
        error={!!error}
        refetch={refetch}
        onShowUsers={handleShowUsers}
      />

      <ModalHolidayDetails
        holiday={selectedHoliday}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </>
  );
};
